import React from "react";

const SkeletonLoader = ({ rowCount = 3, rowHeight = "35px", style }) => {
  const skeletonStyle = {
    borderRadius: "4px",
    background: "linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%)",
    backgroundSize: "200% 100%",
    animation: "skeleton-loading 1.5s infinite",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        ...style,
      }}
    >
      <style>
        {`
          @keyframes skeleton-loading {
            0% {
              background-position: -200% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
        `}
      </style>

      {Array.from({ length: rowCount }).map((_, index) => (
        <div key={index} style={{ ...skeletonStyle, height: rowHeight }} />
      ))}
    </div>
  );
};

export default SkeletonLoader;
